import { useEffect } from 'react';

/**
 * Whether a page is still loading on screen (a PageLoading is up), and when the last one went. A hand-scanner read kept
 * for the next screen waits for it as long as the page loads, never a fixed time from the read (round 41, Ravi: on a
 * slow reload the kept read was dropped, and its line went, while Quick Pick still said "Loading…").
 */
let active = 0;
let endedAt = 0;
const listeners = new Set<() => void>();
const notify = () => listeners.forEach(listener => listener());

export const screenLoading = () => active > 0;
/** When the last loading page went (0 when none has yet). */
export const screenLoadingEndedAt = () => endedAt;

/** Calls `listener` when a page starts or stops loading. Returns the unsubscribe. */
export const onScreenLoadingChange = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/** Marks a page as loading while the caller is mounted. */
export const useScreenLoading = () => {
  useEffect(() => {
    active += 1;
    notify();
    return () => {
      active = Math.max(0, active - 1);
      if (active === 0) endedAt = Date.now();
      notify();
    };
  }, []);
};

/** Tests: no page loading, none ever done. */
export const resetScreenLoading = () => {
  active = 0;
  endedAt = 0;
};
